<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg mypage">
        <div class="container">
          <!-- <p>마이페이지</p> -->
        </div>
      </div>
      <div class="my_page_content custom">
        <div class="container">
          <div class="form_area">
            <!-- <form id="my_page_pw_change" action="/mypage_pwd" method="POST"
                            onsubmit="return formCheckMypagePw(this)"> -->
            <form id="my_page_pw_change" @submit.prevent="checkCurrentPw()">
              <!-- <input type="hidden" name="returnUrl" value="/member/mypage_modify.html"> -->
              <div class="my_page_confirm">
                <h3>프로필 수정</h3>
                <p>
                  회원님의 소중한 개인정보를 안전하게 보호하기 위해 비밀번호를
                  한 번 더 확인합니다.
                </p>
                <input
                  id="user_pw"
                  v-model="currentPW"
                  type="password"
                  class="input"
                  name="user_pw"
                  placeholder="비밀번호를 입력해주세요."
                />
              </div>
              <div class="btn_area">
                <!-- <input type="submit" class="btn_orange" value="확인" onclick="check_pw();"> -->
                <!-- <input
                  type="button"
                  class="btn_orange"
                  value="확인"
                  @click="checkCurrentPw()"
                /> -->
                <input type="submit" class="btn_orange" value="확인" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ModalAlert
        :alertMsg="errMsg"
        :isOpen="errStatus"
        @update:isOpen="updateStatus"
      />
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
// eslint-disable-next-line import/no-cycle
import router from '../router/router.js'
import { myapgePWChk } from '../api/mypage'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'MypageModifyConfirmViews',
  components: {
    ModalAlert,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    const currentPW = ref('')
    // console.log(currentPW);
    const checkCurrentPw = async () => {
      // console.log(currentPW);
      const valueChk = await myapgePWChk(currentPW)
      // console.log(valueChk)
      if (valueChk.status_code === 200) {
        router.push({ path: '/mypage_modify' })
      } else if (valueChk.status_code === 400) {
        if (valueChk.code === 'MB41002400') {
          errStatus.value = true
          errMsg.value = '비밀번호가 입력되지 않았습니다.'
        } else if (valueChk.code === 'MB41003400') {
          errStatus.value = true
          errMsg.value =
            '비밀번호가 올바르지 않습니다.<br>입력하신 비밀번호를 다시 확인해주세요.'
        }
      }
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    onMounted(() => {})
    return {
      errMsg,
      errStatus,
      updateStatus,

      currentPW,
      checkCurrentPw,
    }
  },
}
</script>
